import React from "react";

interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
  onStepClick?: (step: number) => void; // Add a prop to handle step clicks
}

const ProgressBar: React.FC<ProgressBarProps> = ({ currentStep, totalSteps, onStepClick }) => {
  const steps = [
    { id: 1, title: "Basic Details", subtitle: "Step 1" },
    { id: 2, title: "Plot Details", subtitle: "Step 2" },
    { id: 3, title: "Location", subtitle: "Step 3" },
    { id: 4, title: "Amenities", subtitle: "Step 4" },
  ];

  // Corrected logic for step classes based on your HTML example:
  // "completed" for steps already done
  // "upcoming" for the current step (as per your HTML example's current step 1)
  // "active" for steps not yet reached (future steps)
  const getStepClass = (stepNumber: number) => {
    if (stepNumber < currentStep) return "step completed";
    if (stepNumber === currentStep) return "step upcoming"; // Match your HTML for current step
    return "step active"; // Match your HTML for future steps
  };

  // Corrected logic for icons:
  // - Tick for completed steps
  // - Location icon for the current step
  // - Font Awesome circle for future/inactive steps
  const getStepIcon = (stepNumber: number) => {
    if (stepNumber < currentStep) {
      return <img alt="" src={`${process.env.REACT_APP_STATIC_BASE_URL}/frontend/images/icon-tick.png`} />;
    }
    if (stepNumber === currentStep) {
      return <img alt="" src={`${process.env.REACT_APP_STATIC_BASE_URL}/frontend/images/icon-location.png`} />;
    }
    // This is for steps that are "active" (future) according to your HTML example
    return <i className="fas fa-circle"></i>;
  };

  // Determines the class for the 'circle' div itself.
  // In your HTML, the current step has 'circle flag'. Future steps just have 'circle'.
  const getCircleDivClass = (stepNumber: number) => {
    if (stepNumber < currentStep) {
      return "circle flag"; // Completed steps might also have 'flag' if they had an icon.
    }
    if (stepNumber === currentStep) {
      return "circle flag"; // Current step has 'flag'
    }
    return "circle"; // Future steps just have 'circle'
  };


  const handleStepClick = (stepNumber: number) => {
    // Allow navigation only to completed or current steps
    if (stepNumber <= currentStep && onStepClick) {
      onStepClick(stepNumber);
    }
  };

  return (
    <div className="timeline">
      {steps.map((step) => (
        <div key={step.id} className={getStepClass(step.id)}>
          {/* Apply the correct class for the circle div */}
          <div className={getCircleDivClass(step.id)}>
            {getStepIcon(step.id)}
          </div>
          <div className="label">
            {step.id <= currentStep ? (
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault(); // Prevent default anchor behavior
                  handleStepClick(step.id);
                }}
                style={{ cursor: "pointer" }}
              >
                {step.title}
                <br />
                <small>{step.subtitle}</small>
              </a>
            ) : (
              <span style={{ cursor: "not-allowed", opacity: 0.5 }}>
                {step.title}
                <br />
                <small>{step.subtitle}</small>
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProgressBar;